import styled from 'styled-components'
import { MenuItem } from '@material-ui/core'

export const MenuItemFilter = styled(MenuItem)`
	padding-top: 0 !important;
	padding-bottom: 0 !important;
`
